import React from 'react';
import classNames from 'classnames';

import InputAdornment from "@material-ui/core/InputAdornment";
import Input from '@material-ui/core/Input';
import FormControl from '@material-ui/core/FormControl';
import ReactTooltip from 'react-tooltip';

const NumberInput = props => (
    <div className="form-input-container">
        <div className={classNames(props.classes.margin, props.classes.formControl)}>
            <FormControl className={classNames(props.classes.margin, props.classes.formControl)}
                data-tip data-for={props.name}>
                <Input
                    style={{width: "150px"}}
                    inputProps={props.minMaxStep}
                    type="number"
                    name={props.name}
                    value={props.value}
                    onChange={props.handleInputChange}
                    endAdornment={<InputAdornment position="end">{props.unit}</InputAdornment>}
                    />
            </FormControl>
            {props.instructions}
            <ReactTooltip id={props.name} place="bottom" type="light" effect="solid">
                <div>{props.tooltip} </div>
            </ReactTooltip>
        </div>
    </div>
)
export default NumberInput;
